import { toComputerDate, toHumanDate } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {},
      errors: {},
      loading: false
    };
  },
  computed: {
    ...mapState("product", ["product"])
  },
  methods: {
    submitSuccess() {
      this.$message.success("Alterações salvas");
      this.$router.push({
        name: "product-details",
        params: { id: this.product.id }
      });
    },
    successLoad() {
      this.form = {
        ...this.product,
        payment_methods_ids: get(this.product, "payment_methods", []).map(
          p => p.id
        ),
        category_id: get(this.product, "category.id"),
        event_start_at: toHumanDate(this.product?.event_start_at),
        event_end_at: toHumanDate(this.product?.event_end_at)
      };
    },
    onSubmit() {
      this.loading = true;

      const data = {
        option_form: {
          request_address_shopper: true,
          request_cpf_cnpj_shopper: true,
          request_phone_shopper: true,
          coupon_shopper: false,
          instagram_shopper: false,
          request_zip_code: false,
          pos_address_shopper: false
        },
        ...this.form
      };
      if (!parseFloat(data.price_usd)) delete data.price_usd;
      if (!parseFloat(data.price_eur)) delete data.price_eur;
      delete data.tax_install;

      if (this.product.type_product == "onsite_event") {
        delete data.price;
        data.event_start_at = toComputerDate(this.form.event_start_at);
        data.event_end_at = toComputerDate(this.form.event_end_at);
      } else {
        delete data.event_start_at;
        delete data.event_end_at;
      }

      this.$store
        .dispatch("product/put", data)
        .then(this.submitSuccess)
        .catch(error => {
          this.errors = error.response.data;
          if (error.response.data.details) {
            this.$message.error(error.response.data.details);
          }
          this.onSubmitError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitError(data) {}
  }
};
